export default __webpack_public_path__ + "static/SCUBA_Mask-284a5e1e5da02382651864909887138f.png";